import React from "react";
import { RenterTable } from "./overview/RenterTable";
import { OverviewContainer } from "../../common/OverviewContainer";

export function RenterOverview() {
  return (
    <OverviewContainer title={null}>
      <RenterTable />
    </OverviewContainer>
  );
}
